<template>
  <div>
    <b-alert variant="danger" :show="!!errorMessage">{{ errorMessage }}</b-alert>
    <template v-if="!loading && result">
      <b-row>
        <b-col cols="12" lg="6">
          <div class="justify-content-center border-bottom height-100 d-flex align-items-center">
            <div class="text-center">
              <h4 class="h4-bold-uppercase-azure mb-3">La tua spesa<br>annua prevista</h4>
              <h1 class="h1-bold-black mb-4 mt-0">{{ result.spesa_annua.formatNumber() }} €</h1>
            </div>
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="border-bottom">
            <b-row align-v="center">
              <b-col class="py-3">
                <div class="text-center d-block d-lg-none">
                  <i class="d-block icon sgri-gas mx-0 mb-1"></i>
                  <div class=" mb-2">
                    <h3 class="h3-semibold-black mb-0">{{ result.gas.naturale.formatNumber() }} €</h3>
                    <p class="p-medium-gray-600 mb-0">Gas Naturale</p>
                  </div>
                  <div>
                    <h3 class="h3-semibold-black mb-0">{{ result.gas.green }}%</h3>
                    <p class="p-medium-gray-600 mb-0">Gas Green</p>
                  </div>
                </div>
                <div class="d-none d-lg-flex align-items-center justify-content-center">
                  <i class="icon sgri-gas"></i>
                  <div>
                    <h3 class="h3-semibold-black mb-0">{{ result.gas.green }}%</h3>
                    <p class="p-medium-gray-600 mb-0">Gas Green</p>
                  </div>
                </div>
                <img :src="'img/graphs/graph-'+result.gas.level+'.svg'" class="mx-auto d-block mt-1 mt-lg-3">
              </b-col>
              <b-col class="py-3 border-left">
                <div class="text-center d-block d-lg-none">
                  <i class="d-block icon sgri-luce mx-0 mb-1"></i>
                  <div class=" mb-2">
                    <h3 class="h3-semibold-black mb-0">{{ result.luce.elettrica.formatNumber() }} €</h3>
                    <p class="p-medium-gray-600 mb-0">Luce elettrica</p>
                  </div>
                  <div>
                    <h3 class="h3-semibold-black mb-0">{{ result.luce.green }}%</h3>
                    <p class="p-medium-gray-600 mb-0">Luce Green</p>
                  </div>
                </div>
                <div class="d-none d-lg-flex align-items-center justify-content-center">
                  <i class="icon sgri-luce"></i>
                  <div>
                    <h3 class="h3-semibold-black mb-0">{{ result.luce.green }}%</h3>
                    <p class="p-medium-gray-600 mb-0">Luce Green</p>
                  </div>
                </div>
                <img :src="'img/graphs/graph-'+result.luce.level+'.svg'" class="mx-auto d-block mt-1 mt-lg-3">
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6" class="d-none d-lg-block">
          <b-row align-v="center">
            <b-col class="d-flex align-items-center justify-content-center py-3">
              <i class="icon sgri-gas"></i>
              <div>
                <h3 class="h3-semibold-black mb-0">{{ result.gas.naturale.formatNumber() }} €</h3>
                <p class="p-medium-gray-600 mb-0">Gas Naturale</p>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-center py-3 border-left">
              <i class="icon sgri-luce"></i>
              <div>
                <h3 class="h3-semibold-black mb-0">{{ result.luce.elettrica.formatNumber() }} €</h3>
                <p class="p-medium-gray-600 mb-0">Luce elettrica</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6">
          <b-row align-v="center">
            <b-col class="d-flex align-items-center justify-content-center py-3">
              <i class="icon sgri-emissioni mr-3"></i>
              <div>
                <h3 class="h3-semibold-black mb-0">{{ result.emissioni.formatNumber() }}</h3>
                <p class="p-medium-gray-600 mb-0">Kg di emissioni</p>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-center py-3 before-equal">
              <i class="icon sgri-albero mr-3"></i>
              <div>
                <h3 class="h3-semibold-black mb-0">{{ result.alberi_abbattuti.formatNumber() }}</h3>
                <p class="p-medium-gray-600 mb-0">Alberi abbattuti</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <h6 class="h6-medium-gray-600 text-center mt-5 mb-4" v-html="result.text"></h6>

      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1 mt-4 mb-8 border-top">
        </div>
      </div>

      <div>
        <div class="h3-semibold-black text-center mb-7">
          Scopri le migliori offerte web di SGR Luce e Gas
        </div>
        <div class="text-center">
          <a href="https://www.sgrlucegas.com/luce-gas/" target="_blank"
             class="button-yellow-rounded">Scopri le offerte</a>
        </div>
        <!--
        <div class="row">
          <div class="col-12 col-md-6 mb-16">
            <div class="banner"
                 style="background-image:url('https://www.sgrlucegas.com/app/uploads/2021/10/Serena-PREVIEW.jpg')">
              <div class="banner-container">
                <div class="mb-3">
                  <p class="p-medium-azure mb-1">Luce</p>
                  <h3 class="h3-medium-white-uppercase mb-1">Serena Luce</h3>
                  <h2 class="h2-bold-yellow m-0">La risposta migliore ai rincari</h2>
                </div>
                <div class="row banner-footer mt-0">
                  <div class="col-md-8 mb-4 md:mb-0">
                    <a href="https://www.sgrlucegas.com/offerta/serena-luce/" target="_blank"
                       class="button-yellow-rounded">Scopri l’offerta</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="banner"
                 style="background-image:url('https://www.sgrlucegas.com/app/uploads/2020/10/Serena-Gas-1920x768-1.jpg')">
              <div class="banner-container">
                <div class="mb-3">
                  <p class="p-medium-azure mb-1">Gas</p>
                  <h3 class="h3-medium-white-uppercase mb-1">Serena Gas</h3>
                  <h2 class="h2-bold-yellow m-0">La risposta migliore ai rincari</h2>
                </div>
                <div class="row banner-footer mt-0">
                  <div class="col-md-8 mb-4 md:mb-0">
                    <a href="https://www.sgrlucegas.com/offerta/serena-gas/" target="_blank"
                       class="button-yellow-rounded">Scopri l’offerta</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        // -->
      </div>

    </template>
  </div>

</template>

<script>
import { RECAPTCHA_ACTIONS, getRecaptchaToken } from '@/config/recaptcha';

export default {
  name: 'Results',
  data() {
    return {
      id: null,
      thisStep: 6,
      loading: true,
      result: null,
      states: {},
      webPath: process.env.VUE_APP_WEB_PATH,
      email: '',
      phone: '',
      firstname: '',
      lastname: '',
      privacy: null,
      qOptions: null,
      errorMessage: '',
    }
  },
  props: {
    options: {
      type: [Array, Object],
      required: true
    }
  },
  computed: {
    stateCheck: function () {
      return this.privacy;
    }
  },
  mounted() {
    this.qOptions = this.$route.params;
    if (this.$route.query.s) {
      this.qOptions.s = this.$route.query.s;
    }
    this.$emit(this.getResults());
    //if(this.options < this.thisStep) this.$emit('setOptions', this.qOptions)
    if (this.qOptions.step < this.thisStep) this.$router.push({name: 'step-1'})
  },
  created() {
    this.$emit('setCurrent', this.thisStep);
    this.getResults();
  },
  methods: {
    handleError(message, error) {
      if (error) console.log('error', error);
      this.errorMessage = message;
      this.loading = false;
    },
    async getResults() {
      let that = this;
      if (that.qOptions) {
        that.loading = true;
        that.errorMessage = '';
        that.$emit('setHideSteps', true);

        const token = await getRecaptchaToken(RECAPTCHA_ACTIONS.GET_CHECKUP);

        that.axios.post(this.webPath + 'wp-admin/admin-ajax.php?action=get_checkup', {
          ...that.qOptions,
          recaptcha_token: token,
          recaptcha_action: RECAPTCHA_ACTIONS.GET_CHECKUP,
        })
            .then(response => {
              if (response.data && response.data.recaptcha_error) {
                return that.handleError(response.data.message);
              }

              that.result = response.data;
              that.id = that.result.id;
              that.loading = false;
              if (typeof that.$analytics != 'undefined') {
                this.trackFbViewContent('check-up-energetico', 'resoconto');
              }
            })
            .catch(error => {
              that.handleError('Non e\' stato possibile caricare il resoconto. Riprova.', error);
            })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.border-top {
  border-top: 1px solid #516574;
}

.border-bottom {
  border-bottom: 1px solid #516574;
}

.border-left {
  border-left: 1px solid #516574;
}

.icon {
  margin-right: 22px;
  font-size: 40px;
}

.p-medium-gray-600 {
  font-size: 14px !important;
}

.height-100 {
  height: 100%;
}

.before-equal {
  &:before {
    content: '=';
    position: absolute;
    left: -10px;
    font-size: 40px;
    color: #516574;
  }
}

.banner {
  min-height: auto;
  padding: 32px 48px 24px;
}
</style>